import React, { useEffect, useState } from 'react';
import ProductList from './ProductList';
import PropTypes from 'prop-types';

export default function ProductOftenBoughtWithProducts({ productHandle, isMobile, title }) {
    const [products, setProducts] = useState([]);
    const fetchProducts = async () => {
        try {
            const response = await fetch(new URL(`/api/products/handle/${productHandle}/oftenBoughtWith`, process.env.APP_URL));
            if (!response.ok) {
                throw new Error('Something went wrong.');
            }
            const data = await response.json();
            if (data.error) {
                throw new Error(data.error);
            }
            setProducts(data.products);
        } catch (e) {
            console.error(e);
        }
    };
    useEffect(() => {
        fetchProducts();
    }, []);
    if (!products || products.length === 0) {
        return null;
    }
    return (<section
        className={'often-bought-with'}>
        <h2
            className={'text-center'}>{title ?? 'Related Items' }</h2>
        <hr />
        <ProductList
            isMobile={isMobile}
            products={products}
            alignLeft={true}
            historyMode={false}
            addToOrder={false}
            orderId={null}
            featured={false}
            minimized={false}
        />
    </section>);
}

ProductOftenBoughtWithProducts.propTypes = {
    isMobile: PropTypes.bool.isRequired,
    productHandle: PropTypes.string.isRequired,
    title: PropTypes.string,
};